module.exports = __webpack_public_path__ + "static/media/persyaratan.d3db93ab.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/persyaratan.pdf
// module id = 1596
// module chunks = 0